import { createContext, useContext, useState, useMemo } from "react";

const ProfileContext = createContext();

export const useProfile = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error("useProfile must be used within ProfileProvider");
  }
  return context;
};

export const ProfileProvider = ({ children }) => {
  const [profileData, setProfileData] = useState(null);
  const [profileId, setProfileId] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);

  const value = useMemo(
    () => ({
      profileData,
      setProfileData,
      profileId,
      setProfileId,
      currentUserId,
      setCurrentUserId,
    }),
    [profileData, profileId, currentUserId]
  );

  return (
    <ProfileContext.Provider value={value}>
      {children}
    </ProfileContext.Provider>
  );
};
